import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { AnimationActions } from 'Animation';
import SelfServeBuilderSidePanelWithRedux,
  {
    SelfServeBuilderSidePanelTypes,
    SelfServeBuilderSidePanelConstants,
  } from 'SelfServeBuilderSidePanel';
import { SelfServeBuilderPopupTypes } from 'Popups';
import { closePanel } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelActions';
import { SelfServePostBuilderSidePanelTypes } from './SelfServePostBuilderSidePanelConstants';
import * as SelfServePostBuilderSidePanelActions from './SelfServePostBuilderSidePanelActions';
import SectionOrganizer from './SectionOrganizer';
import RecipientManager from './RecipientManager';

export { default as SelfServePostBuilderSidePanelConstants } from './SelfServePostBuilderSidePanelConstants';
export { SelfServePostBuilderSidePanelTypes } from './SelfServePostBuilderSidePanelConstants';
export { default as SelfServePostBuilderSidePanelHandler } from './SelfServePostBuilderSidePanelReducer';

const ANIMATION_FIELD_TOP_OFFSET = -90;
const ANIMATION_DURATION = 700;
const FIELD_TOP_OFFSET = 25;

// manages organizing sections and adding recipients
class SelfServePostBuilderSidePanel extends React.Component {
  constructor(props) {
    super(props);

    this.getActivePanel = this.getActivePanel.bind(this);
    this.getAnimationStartPosition = this.getAnimationStartPosition.bind(this);
    this.getAnimationImageSrc = this.getAnimationImageSrc.bind(this);
    this.displayRecipientManager = this.displayRecipientManager.bind(this);

    this.closePanel = this.closePanel.bind(this);
  }

  getActivePanel() {
    switch (this.props.activePanel) {
      case SelfServePostBuilderSidePanelTypes.SECTION_ORGANIZER:
        return (
          <SectionOrganizer
            displayRecipientManager={this.displayRecipientManager}
          />
        );
      case SelfServePostBuilderSidePanelTypes.RECIPIENT_MANAGER:
        return (
          <div className="self-serve-post-builder-recipient-manager-side-panel">
            <RecipientManager
              closePanel={this.closePanel}
              documentType={this.props.documentType}
              isOverlayVisible={this.props.isOverlayVisible}
              isPublic={this.props.isPublic}
              isTemplateEmpty={this.props.isTemplateEmpty}
              publishedAt={this.props.publishedAt}
            />
          </div>
        );
      default:
        return <div />;
    }
  }

  getAnimationStartPosition() {
    const fieldId = this.props.animationHandler.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION.fieldIdToAnimate;
    const fieldTopValue = document.getElementById(fieldId).getBoundingClientRect().top +
      window.pageYOffset +
      ANIMATION_FIELD_TOP_OFFSET;
    const fieldLeftValue = document.getElementById(fieldId).getBoundingClientRect().left;
    const sidePanelLeftValue = document.getElementById('selfServePostBuilderSidePanel').getBoundingClientRect().left;
    return `translate(-${sidePanelLeftValue - fieldLeftValue}px, ${fieldTopValue}px)`;
  }

  getAnimationImageSrc() {
    const { CHECKBOX, MULTIPLE_CHOICE, TEXTBOX, SIGNATURE } = SelfServeBuilderPopupTypes;
    switch (this.props.animationHandler.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION.fieldType) {
      case TEXTBOX:
      case SIGNATURE:
        return '/images/self-serve-builder/cursor/textbox.png';
      case CHECKBOX:
        return '/images/self-serve-builder/cursor/checkbox.png';
      case MULTIPLE_CHOICE:
        return '/images/self-serve-builder/cursor/multchoice.png';
      default:
        return '';
    }
  }

  closePanel() {
    this.props.closePanel(SelfServeBuilderSidePanelTypes.POST_BUILDER);
  }

  displayRecipientManager() {
    window._track('Add Recipients', 'Template Builder');
    window._track('Add Recipients | Add Recipients', 'Template Builder');
    this.props.displayRecipientManager();
  }

  render() {
    const animationInProgress = (
      this.props.animationHandler.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION.step > 0
    );
    return (
      <React.Fragment>
        <div
          id="selfServePostBuilderSidePanel"
          className="self-serve-post-builder-side-panel"
        >
          {this.props.animationHandler.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION.started &&
          !this.props.animationHandler.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION.finished &&
            <img
              className="animation-self-serve-field-done-img"
              alt=""
              style={{
                top: FIELD_TOP_OFFSET,
                transition: `transform ${ANIMATION_DURATION}ms ease-in-out`,
                transform: animationInProgress ? 'none' : this.getAnimationStartPosition(),
              }}
              src={this.getAnimationImageSrc()}
            />
          }
        </div>
        <SelfServeBuilderSidePanelWithRedux
          closeWidth={0}
          isOverlayVisible={this.props.isOverlayVisible}
          openWidth={this.props.openWidth}
          panelType={SelfServeBuilderSidePanelTypes.POST_BUILDER}
        >
          { this.getActivePanel() }
        </SelfServeBuilderSidePanelWithRedux>
      </React.Fragment>
    );
  }
}

SelfServePostBuilderSidePanel.defaultProps = {
  closePanel: () => {},
  isOverlayVisible: false,
  isTemplateEmpty: false,
  openWidth: SelfServeBuilderSidePanelConstants.DEFAULT_OPEN_PANEL_WIDTH,
  publishedAt: '',
};

SelfServePostBuilderSidePanel.propTypes = {
  activePanel: PropTypes.oneOf([
    SelfServePostBuilderSidePanelTypes.SECTION_ORGANIZER,
    SelfServePostBuilderSidePanelTypes.RECIPIENT_MANAGER,
  ]).isRequired,
  closePanel: PropTypes.func,
  documentType: PropTypes.string.isRequired,
  displayRecipientManager: PropTypes.func.isRequired,
  animationHandler: PropTypes.shape({
    SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION: PropTypes.shape({
      started: PropTypes.bool,
      finished: PropTypes.bool,
      fieldIdToAnimate: PropTypes.string,
      fieldType: PropTypes.oneOf(Object.values(SelfServeBuilderPopupTypes)),
      step: PropTypes.number,
    }),
  }).isRequired,
  isOverlayVisible: PropTypes.bool,
  isPublic: PropTypes.bool.isRequired,
  isTemplateEmpty: PropTypes.bool,
  openWidth: PropTypes.number,
  publishedAt: PropTypes.string,
};


const mapStateToProps = ({
  AnimationReducer,
  SelfServePostBuilderSidePanelHandler,
  SelfServeBuilderReducer,
}) => ({
  ...SelfServePostBuilderSidePanelHandler.ActiveSidePanelHandler,
  animationHandler: AnimationReducer,
  documentType: SelfServeBuilderReducer.documentType,
  isPublic: SelfServeBuilderReducer.isPublic,
  publishedAt: SelfServeBuilderReducer.publishedAt,
  scrollOffset: SelfServeBuilderReducer.scrollOffset,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...SelfServePostBuilderSidePanelActions,
    ...AnimationActions,
    closePanel,
  }, dispatch)
);

export const SelfServePostBuilderSidePanelWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelfServePostBuilderSidePanel);

export default SelfServePostBuilderSidePanelWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/index.jsx